import React from 'react'
import { Modal } from '@web/walter-ui-kit'
import Content from './Content'

interface Props {
    isOpen: boolean
    fieldName?: string
    onClose: () => void
}

function MistakeModal({ isOpen, onClose, fieldName }: Props) {
    return (
        <Modal
            type="dialog"
            withHeaderBorder={false}
            onClose={onClose}
            isOpen={isOpen}
            dataPointer="mistake_modal"
            size="xs"
        >
            <Content onClose={onClose} fieldName={fieldName} />
        </Modal>
    )
}

export default MistakeModal
